// Central route builders for submission lifecycle navigation.
//
// Existing pages navigate with hard-coded strings and two different query-param
// conventions (?edit= for edit flows, ?submissionId= for read-only/billing).
// These helpers preserve those exact conventions while adding type-aware
// dispatch so CONTINUING_REVIEW submissions route to their own form pages and
// NEW_SUBMISSION behavior stays byte-for-byte identical.

import { SubmissionType } from '../lib/supabaseClient';

export const submissionDetailsRoute = (submissionId: string) => `/submissions/${submissionId}`;

export const billingRoute = (submissionId?: string) =>
  submissionId ? `/billing?submissionId=${submissionId}` : '/billing';

export const readOnlySubmissionRoute = (submissionId: string) =>
  `/view-submission?submissionId=${submissionId}`;

/** Continue editing a DRAFT submission. */
export const draftEditRoute = (submissionId: string, submissionType: SubmissionType) => {
  if (submissionType === 'CONTINUING_REVIEW') {
    return `/continuing-reviews/${submissionId}/edit`;
  }
  return `/new-submission?edit=${submissionId}`;
};

/** Respond to NEEDS_ACTION feedback. */
export const needsActionEditRoute = (submissionId: string, submissionType: SubmissionType) => {
  if (submissionType === 'CONTINUING_REVIEW') {
    return `/continuing-reviews/${submissionId}/respond`;
  }
  return `/edit-submission?edit=${submissionId}`;
};

/** Start a brand-new continuing review from an approved source submission. */
export const startContinuingReviewRoute = (sourceSubmissionId: string) =>
  `/submissions/${sourceSubmissionId}/continuing-review/new`;

export const adminReviewRoute = (submissionId: string) => `/admin/submissions/${submissionId}`;
